//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AppConfig from '../config/app'
import API from '../api'
import qs from 'qs'

// 是否是H5渠道
let h5 = false

export default {
  name: 'm-result',
  created () {
    delete this.$route.query.activityCode

    // 判断活动是否可用
    this.$http('/api/activityNoLogin/getActivityStatus?activityCode=' + this.activityId).then(response => {
      if (response.data.resultCode === 'error') {
        this.inActivity = false
      } else {
        this.inActivity = true
      }
    })

    // 京东卡
    this.$http.get('/api/activity/getDiscountInfoByProduct?handOutNode=4&productCode=' + this.$route.params.productId).then((response) => {
      if (response.data.resultCode === 'success') {
        this.jdCardValue = response.data.data
        this.hasJDCard = true
      }
    })
  },
  mounted () {
    var _this = this
    if (this.$store.state.app.innerCode === '148198068433580000') {
      var utmSource = _this.$route.query.utm_source
      if (!utmSource || utmSource === 'wechat' || utmSource === 'wx') {
        utmSource = 'wechat'
      }
      let orderQuerenURL = '/api/hqdqx/orderQueren/'
      if (this.h5) {
        orderQuerenURL = '/api/channel/hqdqx/orderQueren/'
      }
      this.$http.get(orderQuerenURL + this.$store.state.app.innerCode + '/' + this.$store.state.app.productCode + '/' + this.$store.state.order.unionCode).then(response => {
        window._hmt.push(['_trackOrder', {
          'orderId': response.data.busOrder.orderCode,
          'orderTotal': response.data.underwritingInfoList[0].premium / 100,
          'item': [
            {
              'skuId': _this.$store.state.app.productCode,
              'skuName': response.data.busProductRelation.productName,
              'category': utmSource,
              'Price': response.data.underwritingInfoList[0].premium / 100,
              'Quantity': 1
            }
          ]}
        ])
      })
    }
    window.jQuery(window).on('popstate', this.go)
    this.$store.commit('updateProductId', this.$route.params.productId)
    this.$store.commit('updateUserId', this.$route.params.userId)
    // this.$store.commit('updateOrderOpenId', this.$route.params.openId)
    this.$store.commit('updateOrderUnionOrderCode', this.$route.params.unionCode)
    document.title = '提交详情'
    // 被逼的
    setTimeout(() => {
      this.changeSwiperPositon()
    }, 500)
    if (this.$route.query.utmSource && this.$route.query.utmSource === 'h5') {
      this.$route.query.requireJsApi = true
      this.h5 = true
    }
    if (!this.h5) {
      this.show = true
    } else {
      API.getH5Configuration(this).then(data => {
        if (!this.$store.state.h5.configuration.isNull && data.successFinalPage === 'submitSucc') {
          this.show = true
          this.successFinalPage = true
        } else if (!this.$store.state.h5.configuration.isNull && data.successUrl !== '') {
          window.location.replace(data.successUrl)
        } else {
          this.show = true
        }
      })
    }
  },
  destroyed () {
    // if (window.removeEventListener) {
    //   window.removeEventListener('popstate', this.go)
    // } else if (window.detachEvent) {
    //   window.detachEvent('onpopstate', this.go)
    // }
    window.jQuery(window).off('popstate', this.go)
  },
  data () {
    return {
      index: 0,
      show: false,        // 默认不显示页面
      successFinalPage: false,
      h5: h5,
      hasJDCard: false,
      jdCardValue: '0元京东卡',
      inActivity: false,
      activityId: '151019418799579'
    }
  },
  computed: {
    isWKB () {
      if (['149673178664394306', '148198068433580000'].indexOf(this.$store.state.order.userId) === -1) {
        return false
      }
      return true
    },
    activity1111DrawURL () {
      return window.location.protocol + '//' + window.location.hostname + '/anniversaries/2017/1111-draw'
    },
    xPath () {
      // if (this.$store.state.activity.innerCodes.indexOf(this.$store.state.order.userId) !== -1) {
      if (window.location.pathname.indexOf('insurePolicy') !== -1) {
        return 'activityProduct'
      }
      return 'illness'
    },
    swiperList () {
      return [
        {
          img: 'static/images/zxb_banner.png',
          url: this.h5
            ? (window.location.protocol + '//' + window.location.hostname + '/' + 'channel/illness/insurePolicy/' + (AppConfig.app.test ? '152411995379088878' : '152524346503451854') + '/' + this.$route.params.userId + '?' + qs.stringify(this.$route.query))
            : (window.location.protocol + '//' + window.location.hostname + '/') + this.xPath + '/insurePolicy/' + this.$route.params.userId + '/' + (AppConfig.app.test ? '152411995379088878' : '152524346503451854') + '?requireJsApi=true'
        },
        {
          img: 'static/images/nianjinxian_banner.png',
          url: (window.location.protocol + '//' + window.location.hostname + '/') + 'explosions/#/' + this.$route.params.userId + '/' + (AppConfig.app.test ? '151013300258317638' : '151072428587363110') + '?' + qs.stringify(this.$route.query)
        },
        {
          img: 'static/images/xiaoqinbao_banner.png',
          url: (window.location.protocol + '//' + window.location.hostname + '/') + 'explosions/#/' + this.$route.params.userId + '/' + (AppConfig.app.test ? '150831059068987214' : '150840325766681140') + '?' + qs.stringify(this.$route.query)
        },
        {
          img: 'static/images/aeonlife_zhongji.png',
          url: (window.location.protocol + '//' + window.location.hostname + '/') + 'explosions/#/' + this.$route.params.userId + '/' + (AppConfig.app.test ? '150476691002746473' : '150537492578996275') + '?' + qs.stringify(this.$route.query)
        },
        {
          img: 'static/images/dread_disease_banner.png',
          url: this.h5
            ? (window.location.protocol + '//' + window.location.hostname + '/' + 'channel/illness/insurePolicy/' + (AppConfig.app.test ? '149559395942738681' : '149614236499831794') + '/' + this.$route.params.userId + '?' + qs.stringify(this.$route.query))
            : (window.location.protocol + '//' + window.location.hostname + '/' + this.xPath + '/insurePolicy/' + this.$route.params.userId + '/' + (AppConfig.app.test ? '149559395942738681' : '149614236499831794') + '?requireJsApi=true')
        },
        {
          img: 'static/images/hqdy_recommen_banner.png',
          url: (window.location.protocol + '//' + window.location.hostname + '/') + 'hqdy/#/' + this.$route.params.userId + '/' + (AppConfig.app.test ? '149792907872138096' : '149792885824813849') + '?' + qs.stringify(this.$route.query)
        },
        {
          img: 'static/images/bybs_banner.png',
          url: this.h5
            ? (window.location.protocol + '//' + window.location.hostname + '/' + 'channel/illness/insurePolicy/' + (AppConfig.app.test ? '149301981977264138' : '149421366832021029') + '/' + this.$route.params.userId + '?' + qs.stringify(this.$route.query))
            : (window.location.protocol + '//' + window.location.hostname + '/') + this.xPath + '/insurePolicy/' + this.$route.params.userId + '/' + (AppConfig.app.test ? '149301981977264138' : '149421366832021029') + '?requireJsApi=true'
        },
        {
          img: 'static/images/life_banner.png',
          url: this.h5
            ? (window.location.protocol + '//' + window.location.hostname + '/' + 'channel/illness/insurePolicy/' + (AppConfig.app.test ? '149146529095616548' : '149251955998404923') + '/' + this.$route.params.userId + '?' + qs.stringify(this.$route.query))
            : window.location.protocol + '//' + window.location.hostname + '/' + this.xPath + '/insurePolicy/' + this.$route.params.userId + '/' + (AppConfig.app.test ? '149146529095616548' : '149251955998404923') + '?requireJsApi=true'
        },
        {
          img: 'static/images/accident_banner.png',
          url: this.h5
            ? (window.location.protocol + '//' + window.location.hostname + '/' + 'channel/illness/insurePolicy/' + (AppConfig.app.test ? '149173252548863780' : '149329577605090390') + '/' + this.$route.params.userId + '?' + qs.stringify(this.$route.query))
            : window.location.protocol + '//' + window.location.hostname + '/' + this.xPath + '/insurePolicy/' + this.$route.params.userId + '/' + (AppConfig.app.test ? '149173252548863780' : '149329577605090390') + '?requireJsApi=true'
        }
      ]
    },
    tip () {
      if (this.$store.state.order.confirmFeedback) {
        return '如果您在回访问卷中点选为“否”或未进行在线回访，保险公司的客服将以电话方式再次和您确认回访内容，来电号码为0756-6997966，请保持手机畅通；'
      }
      return '如果您在回访问卷中点选为“否”或未进行在线回访，保险公司的客服将以电话方式再次和您确认回访内容，来电号码为0756-6997966，请保持手机畅通；'
    }
  },
  methods: {
    go (event) {
      // window.history.pushState('forward', null, '#')
      window.history.forward(1)
      // history.go(1)
    },
    changeSwiperPositon () {
      let height = window.jQuery('.vux-slider').height() / 2
      window.jQuery('.left-nav, .right-nav').css({top: height + 'px', opacity: 0.3})
    },
    goEvaluation () {
      this.$http.get('/api/hqdqx/findEvaluate/' + this.$store.state.order.unionOrderCode).then(response => {
        if (response.data) {
          this.$vux.toast.show({
            type: 'text',
            text: '客官，不能重复评价哦',
            position: 'top',
            width: '20em'
          })
        } else {
          this.$router.push({name: 'Evaluation', params: {productId: this.$store.state.order.productId, userId: this.$store.state.order.userId, unionCode: this.$store.state.order.unionOrderCode}, query: this.$route.query})
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Result.vue